<template>
  <v-dialog
    persistent
    :value="opened"
    width="600"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="cancel()"
    @keydown.enter="proceed()"
  >
    <v-card block flat class="paper-filed-dialog">
      <v-card-title class="dialog-title">
        Enter the name of the paper-filed return:
      </v-card-title>

      <v-card-text class="dialog-content">
        <v-text-field
          v-model="returnName"
          hide-details
          outline
          placeholder="Enter tax return package name"
          single-line
          ref="returnNameInput"
        />
      </v-card-text>

      <v-card-actions class="dialog-actions">
        <v-spacer />

        <v-btn
          flat
          outline
          large
          class="grey text-none font-weight-bold"
          @click="cancel()"
        >
          Cancel
        </v-btn>

        <v-btn
          large
          color="primary"
          class="font-weight-bold"
          @click="proceed()"
          :disabled="!returnName || !returnName.trim()"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    opened: {
      type: Boolean,
    },
  },

  data() {
    return {
      returnName: '',
    };
  },

  methods: {
    cancel() {
      this.returnName = '';
      this.$emit('cancel');
    },

    proceed() {
      if (this.returnName && this.returnName.trim()) {
        this.$emit('proceed', this.returnName.trim());
        this.returnName = '';
      }
    },
  },

  watch: {
    opened(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (this.$refs.returnNameInput) {
            this.$refs.returnNameInput.focus();
          }
        });
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
.paper-filed-dialog {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.dialog-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  padding: 32px 32px 16px;
  align-items: center;
}

.dialog-content {
  padding: 0 32px 24px;
}

.dialog-actions {
  padding: 0 32px 32px;
  gap: 12px;
}

.return-name-input {
  box-sizing: border-box;
  height: 40px;
  padding: 0 8px;
  width: 100%;

  background-color: var(--gray-0);
  border: 0;
  border-radius: 4px;
  outline: 1px solid var(--gray-200);

  font-family: var(--font-family-sans);
  line-height: 40px;
}
.return-name-input.selected:not(:disabled) {
  box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.25);
  outline: 2px solid var(--blue-500);
}
</style>
